<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="工號">
              <a-input  v-model="queryParam.empNo"  allow-clear></a-input>
            </a-form-item>
            <a-form-item label="廠區">
              <a-input  v-model="queryParam.factoryCode"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="法人">
              <a-input  v-model="queryParam.companyCode"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="siteId">
              <a-input  v-model="queryParam.siteId"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="費用代碼">
              <a-input  v-model="queryParam.costCode"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="事業群">
              <a-input  v-model="queryParam.bgCode"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="在職/離職">
              <a-select v-model="queryParam.jobSt" placeholder="請選擇在職/離職" allowClear>
                <a-select-option value="JOB_ST001">JOB_ST001 在職（Y）</a-select-option>
                <a-select-option value="JOB_ST004">JOB_ST004 離職（N）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="人員類型">
              <a-select v-model="queryParam.empType" placeholder="請選擇人員類型" allowClear>
                <a-select-option value="EO">EO 正式工（Y）</a-select-option>
                <a-select-option value="ET">ET 退休返聘（Y）</a-select-option>
                <a-select-option value="CON">CON 顧問（N）</a-select-option>
                <a-select-option value="EB">EB 廠商派駐（N）</a-select-option>
                <a-select-option value="ED">ED 派遣工（N）</a-select-option>
                <a-select-option value="EE">EE 勤工助學（N）</a-select-option>
                <a-select-option value="EF">EF 學徒工（N）</a-select-option>
                <a-select-option value="EJ">EJ 見習生（N）</a-select-option>
                <a-select-option value="EP">EP 實習工（N）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('emp_chr_employee')">导出</a-button>
      <a-button type="primary" icon="sync" @click="showSyncModal">同步員工信息</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <p>備註：</p>
        <p>JOB_ST001 在職、JOB_ST004 離職</p>
        <p>EO 正式工、ET 退休返聘、CON 顧問、EB 廠商派駐、ED 派遣工、EE 勤工助學、EF 學徒工、EJ 見習生、EP 實習工</p>

      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <emp-chr-employee-modal ref="modalForm" @ok="modalFormOk"></emp-chr-employee-modal>
    <a-modal
      title="同步員工信息"
      :visible="syncModalVisible"
      @ok="confirmSyncEmployees"
      @cancel="cancelSyncModal"
      :confirmLoading="syncModalConfirmLoading"
      :width="600"
    >
      <a-form>
        <a-form-item label="工號" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
          <a-textarea
            v-model="employeeNos"
            placeholder="请输入工号，多个工号请用逗号(,)分隔"
            :rows="4"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
          <div style="margin-top: 8px; font-size: 12px; color: #999;">
            示例: E00001,E00002,E00003
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpChrEmployeeModal from './modules/EmpChrEmployeeModal'

  export default {
    name: 'EmpChrEmployeeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpChrEmployeeModal
    },
    data () {
      return {
        description: 'emp_chr_employee管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'工號',
            align:"center",
            dataIndex: 'empNo'
          },
          {
            title:'廠區',
            align:"center",
            dataIndex: 'factoryCode'
          },
          {
            title:'法人',
            align:"center",
            dataIndex: 'companyCode'
          },
          {
            title:'siteId',
            align:"center",
            dataIndex: 'siteCode'
          },
          {
            title:'費用代碼',
            align:"center",
            dataIndex: 'costCode'
          },
          {
            title:'事業群',
            align:"center",
            dataIndex: 'bgCode'
          },
          {
            title:'在職/離職',
            align:"center",
            dataIndex: 'jobSt'
          },
          {
            title:'人員類型',
            align:"center",
            dataIndex: 'empType'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/chrEmployee/empchremployees",
          delete: "/sys/chrEmployee/empchremployee",
          deleteBatch: "/sys/chrEmployee/empchremployee/batch",
          exportXlsUrl: "/sys/chrEmployee/export-xls",
          importExcelUrl: "sys/chrEmployee/import-excel",
          syncEmployee: "/sys/chrEmployee/syncByEmpNo"
          
        },
        dictOptions:{},
        superFieldList:[],
        syncModalVisible: false,
        syncModalConfirmLoading: false,
        employeeNos: ''
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      initDictConfig(){
      },
// 显示同步模态框
      showSyncModal() {
        this.employeeNos = '';
        this.syncModalVisible = true;
      },

      // 确认同步员工信息
      confirmSyncEmployees() {
        if (!this.employeeNos || this.employeeNos.trim() === '') {
          this.$message.warning('请输入工号');
          return;
        }

        // 处理工号输入，支持单个和多个工号
        const empNos = this.employeeNos
          .split(',')
          .map(no => no.trim())
          .filter(no => no !== '');

        if (empNos.length === 0) {
          this.$message.warning('请输入有效的工号');
          return;
        }

        this.syncModalConfirmLoading = true;
        this.syncEmployeeData(empNos).finally(() => {
          this.syncModalConfirmLoading = false;
        });
      },

      // 取消同步弹窗
      cancelSyncModal() {
        this.syncModalVisible = false;
        this.employeeNos = '';
      },

      // 调用同步员工接口的实际方法（修改为循环调用）
      syncEmployeeData(employeeNos) {
        const that = this;
        let successCount = 0;
        let failCount = 0;
        let failMessages = [];

        // 创建同步Promise数组
        const syncPromises = employeeNos.map(empNo => {
          // 构造GET请求URL，注意这里使用路径参数
          const url = `${this.url.syncEmployee}/${empNo}`;

          return this.$http.get(url).then((res) => {
            if (res.success) {
              successCount++;
              return { success: true, empNo: empNo };
            } else {
              failCount++;
              failMessages.push(`${empNo}: ${res.message || '同步失败'}`);
              return { success: false, empNo: empNo, message: res.message || '同步失败' };
            }
          }).catch((err) => {
            failCount++;
            const errorMsg = `${empNo}: ${err.message || '同步过程中发生错误'}`;
            failMessages.push(errorMsg);
            return { success: false, empNo: empNo, message: err.message || '同步过程中发生错误' };
          });
        });

        // 执行所有同步请求
        return Promise.all(syncPromises).then(results => {
          // 构造总结消息
          let message = `同步完成！成功: ${successCount} 个`;
          if (failCount > 0) {
            message += `，失败: ${failCount} 个`;
          }

          if (failCount > 0) {
            this.$message.warning(message);
            // 显示失败详情（可选，如果失败数量不多的话）
            if (failMessages.length <= 5) {
              failMessages.forEach(msg => {
                this.$message.error(msg);
              });
            } else {
              console.log('同步失败详情:', failMessages);
            }
          } else {
            this.$message.success(message);
          }

          this.syncModalVisible = false;
          this.employeeNos = '';
          // 同步完成后刷新列表
          this.loadData();
        }).catch((err) => {
          this.$message.error('同步过程中发生未知错误: ' + (err.message || err));
        });
      },


    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
